import axiosInstance from '@/utils/api.js'

function validation (payload) {
  payload.is_enabled = parseInt(payload.is_enabled, 10)
  payload.group_id = parseInt(payload.group_id, 10)
}

var state = {
  chat_settings: []
}

var getters = {
  CHAT_SETTINGS: (state) => {
    return state.chat_settings
  }
}

var mutations = {
  SET_CHAT_SETTINGS: (state, payload) => {
    state.chat_settings = payload
  }
}

var actions = {
  GET_CHAT_SETTINGS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/ts_chat_settings')
    if (result.status === 200) {
      context.commit('SET_CHAT_SETTINGS', result.data)
    }
  },
  CREATE_CHAT_SETTINGS: (context, payload) => {
    validation(payload)
    return axiosInstance.post('/settings/ts_chat_settings', payload)
  },
  UPDATE_CHAT_SETTINGS: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/ts_chat_settings', payload)
  },
  DELETE_CHAT_SETTINGS: (context, payload) => {
    return axiosInstance.delete('/settings/ts_chat_settings?id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/ts_chat.js